import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/crm/activities"; 
const apiBulkEndpoint = API_BASE_URL_ENV() + "/admin/crm/activities-bulk-create"; 

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
    
    activitiesBulkCreate(data){
        return http.post(apiBulkEndpoint, data)
    }
}
